export default __webpack_public_path__ + "/dist/images/voyager.b6db5be73408b5f83635801691435e65.png";